import { message, Modal } from "antd";
import { analytics, trackEvent } from "src/analytics";
import { EVENTS, SCREENS } from "src/analytics/events";
import { SUBSCRIPTION_CONST } from "src/common/constants";
import API from 'src/apis';
import { SOURCES_ICONS } from 'src/common/constants';

const modifyHistoryResponseData = (respData: any) => {
    const modifiedResponse: any = {};
    const keysToCheck = ['limit', 'page', 'full_count'];

    keysToCheck.forEach(key => {
        if (respData.hasOwnProperty(key)) {
            modifiedResponse[key] = respData[key];
        }
    });

    if (respData.hasOwnProperty('data') && (respData['data'] || []).length) {
        const modifiedHistoryData = respData.data.map((history: any) => {
            const commonHistoryObject = {
                id: history?._id?.$oid || null,
                userId: history?.user_id || null,
                status: history?.status || null,
                openAiResponses: (history?.qa_data || []).map((qa: any) => ({
                    query: qa?.question || null,
                    answer: qa?.response ? qa?.response.replace(/\n/g, '<br>') : null,
                    sources: (qa?.articlelist && qa?.articlelist !== 'Try again by rephrasing')
                        ? typeof qa?.articlelist === 'object'
                            ? { ArticleTitle: qa?.articlelist }
                            : typeof qa?.articlelist === 'string'
                                ? JSON.parse(qa?.articlelist)
                                : null
                        : null,
                    loader: false,
                    conversation_id: history?.conversation_id || null,
                    loading_text: '',
                    reference_pages: qa?.reference_pages || []
                }))
            };

            if (history?.is_pdf === true) {
                return {
                    ...commonHistoryObject,
                    is_pdf: true,
                    pdfData: {
                        document_id: history.document_id,
                        document_url: history.document_url,
                        document_name: history.document_name || 'test.pdf'
                    }
                };
            } else {
                return {
                    ...commonHistoryObject
                };
            }
        });

        modifiedResponse.data = modifiedHistoryData;
    } else {
        modifiedResponse.data = [];
    }

    return modifiedResponse;
};

export const getQueryParams = (search: string) => {
    if (!search) return {};
    const queryParams = new URLSearchParams(search);
    const params: { [key: string]: string } = {};

    queryParams.forEach((value, key) => {
        params[key] = value;
    });
    return params;
}

export const getCurrentScrren = (location: string) => {
    switch (location) {
        case '/profile':
            return SCREENS.PROFILE_PAGE;
        case '/history':
            return SCREENS.HISTORY_PAGE;
        case '/login':
            return SCREENS.LOGIN_PAGE;
        case '/pdf-chat':
            return SCREENS.PDF_CHAT;
        case '/':
            return SCREENS.LANDING_PAGE;
        default:
            return SCREENS.LANDING_PAGE;
    }
}

export const getaudioUri = (base64Sound: any) => {
    const audioData = atob(base64Sound);
    const arrayBuffer = new Uint8Array(audioData.length);

    for (let i = 0; i < audioData.length; i++) {
        arrayBuffer[i] = audioData.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: 'audio/wav' });
    const audioUri = URL.createObjectURL(blob);

    return audioUri;
}

export const logoutSession = () => {
    Modal.confirm({
        // type: 'error',
        title: 'Session Expired',
        content: 'Your login session has expired. Please log in again.',
        centered: true,
        onOk() {
            localStorage.clear();
            analytics?.logout();
            setTimeout(() => {
                window.location.reload();
            }, 800);
        },
        cancelButtonProps: { style: { display: 'none' } },
        style: {
            backgroundImage: 'linear-gradient(135deg, #4B22E5, #A553EE)',
            borderColor: 'transparent'
        },
    });
}

export const getToken = (): string => {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        logoutSession();
    }
    return token;
};

export const onPressLogout = () => {
    Modal.confirm({
        type: 'confirm',
        title: 'Logout Confirmation',
        content: 'Are you sure you want to log out? We hope to see you again soon!',
        centered: true,
        onOk() {
            trackEvent(EVENTS.TAP_ON_LOGOUT_ICON, {
                screen_name: SCREENS.PROFILE_PAGE,
                utm: true,
                search: window.location.search
            });

            analytics?.logout();
            localStorage.clear();
            setTimeout(() => {
                window.location.reload();
            }, 800);
        },
        okButtonProps: { style: { background: 'linear-gradient(135deg, #4B22E5, #A553EE)' } },
        style: {
            backgroundImage: 'linear-gradient(135deg, #4B22E5, #A553EE)',
            borderColor: 'transparent'
        },
    });
};

export const getFeatureByPlan = (planName: string) => {
    switch (planName) {
        case SUBSCRIPTION_CONST.BASIC:
            return [
                { available: true, text: '20 Free AI credits' },
                { available: true, text: 'Chat with your own research paper within available credits' },
                { available: true, text: 'Additional Features to come within available credits' },
                { available: false, text: 'Unlimited Searches' },
            ];
        case SUBSCRIPTION_CONST.PREMIUM:
            return [
                { available: true, text: 'Unlimited AI credits' },
                { available: true, text: 'Chat with your own research paper within available credits' },
                { available: true, text: 'Additional Features to come' },
                { available: true, text: 'Unlimited Searches' },
            ];
        case SUBSCRIPTION_CONST.ENTERPRISE:
            return [
                { available: true, text: 'All Pro features' },
                { available: true, text: 'Greater than 20 licences' }
            ];
        default:
            return [
                { available: true, text: '20 AI credits' },
                { available: false, text: 'Unlimited Searches' },
                { available: false, text: 'Focus Mode' },
                { available: false, text: 'Group Research to Workspaces' },
                { available: false, text: 'Bring your own Data (Chat with your own Research paper)' },
                { available: false, text: 'Additional Features to come' },
            ];
    }
};

export const fetchTatvaAiToken = async (
    authToken: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    needReload: boolean = true
) => {
    try {
        const tokenData = await API.FetchTatvaAiToken({ 'dr_lite_token': authToken });

        if (tokenData?.tatva_jwt_token && tokenData?.tatva_jwt_token !== 'Error') {
            localStorage.setItem('token', tokenData.tatva_jwt_token);
            localStorage.setItem('from_vendor', 'true');
            const { data: userProfile = null } = await API.GetProfileWithToken(tokenData.tatva_jwt_token);
            if (userProfile) {
                localStorage.setItem('userDetails', JSON.stringify(userProfile));
            }
            await sleep(2000);
            needReload && window.location.reload();
            return tokenData;
        } else {
            throw new Error('Failed to verify auth token!');
        }
    } catch (error) {
        message.error('Failed to verify auth token!');
        console.log(error);
        analytics?.logout();
        localStorage.clear();
        setLoading(false);
    }
};

export const removeAuthTokenFromURL = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('authToken');
    url.searchParams.delete('id');
    url.searchParams.delete('app');
    window.history.replaceState(null, '', url.toString());
};

export const sleep = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

export const getFaviconUrl = (sourceLink: string, index: number) => {
    try {
        const url = new URL(sourceLink);
        // if (url.hostname === 'www.ncbi.nlm.nih.gov') return SOURCES_ICONS[index % SOURCES_ICONS.length];
        return `https://www.google.com/s2/favicons?domain=${url.hostname}&sz=24`;
    } catch (e) {
        return SOURCES_ICONS[index % SOURCES_ICONS.length];
    }
};

export const checkForCredits = async () => {
    try {
        const { status, credit } = await API.PingCredit();
        if (status !== 'success') {
            throw new Error('Failed to fetch credits');
        }
        if (credit <= 0) {
            return 0;
        }
        return credit;
    } catch (error) {
        return 0;
    }
}

export const showNoCreditPopUp = (onpressok = () => { }) => {
    const app = localStorage.getItem('app') || 'tatva_ai';
    if (app === 'zymedelite') {
        Modal.confirm({
            title: 'Credit Expired',
            // content: 'Your credits have been exhausted. Please contact the administrator to add more credits in order to continue using Tatva AI.',
            content: 'Your credits have been exhausted. It will be credited soon.',
            centered: true,
            onOk() { },
            okText: 'Upgrade to pro',
            // cancelButtonProps: { style: { display: 'none' } },
            okButtonProps: {
                style: {
                    backgroundImage: 'linear-gradient(135deg, #4B22E5, #A553EE)',
                    borderColor: 'transparent'
                },
            }
        });
    } else {
        Modal.confirm({
            title: 'Credit Expired',
            content: 'Please subscribe to continue using Tatva AI.',
            centered: true,
            onOk() { onpressok() },
            okText: 'Upgrade to pro',
            // cancelButtonProps: { style: { display: 'none' } },
            okButtonProps: {
                style: {
                    backgroundImage: 'linear-gradient(135deg, #4B22E5, #A553EE)',
                    borderColor: 'transparent'
                },
            }
        });
    }
};

export type AppType = "zymedelite" | "medeco" | "ask_tatva" | "tatva_ai";

export const setAppType = (
    searchParams: URLSearchParams,
    setStateAction: React.Dispatch<React.SetStateAction<AppType>>
) => {
    const app = searchParams.get('app') || localStorage.getItem('app');

    const appType: AppType =
        app === 'zymedelite' ? 'zymedelite' :
            app === 'medeco' ? 'medeco' :
                app === 'ask_tatva' ? 'ask_tatva' :
                    'tatva_ai';

    localStorage.setItem('app', appType);
    setStateAction(appType);
}

// PARSE GPT TEXT.
// export const parseText = (text: string) => {
//     const lines = text.split('\n');
//     const elements: any[] = [];

//     lines.forEach((line, index) => {
//         if (line.startsWith('### ')) {
//             elements.push(<h3 key={ index } > { line.substring(4) } </h3>);
//         } else if (line.startsWith('#### ')) {
//             elements.push(<h4 key={ index } > { line.substring(5) } </h4>);
//         } else if (line.startsWith('- **')) {
//             const parts = line.split('**');
//             elements.push(
//                 <p key={ index } >
//             <strong>{ parts[1]}: </strong> {parts[2].trim()}
//             </p>
//             );
//         } else if (line.startsWith('**')) {
//             const parts = line.split('**');
//             elements.push(
//                 <p key={ index } >
//             <strong>{ parts[1]}: </strong> {parts[2].trim()}
//             </p>
//             );
//         } else if (line.trim() !== '') {
//             elements.push(<p key={ index } > { line.trim() } </p>);
//         }
//     });

//     return elements;
// };

// const parseText = (text: string) => {
//     const lines = text.split('\n').filter(line => line.trim() !== '');

//     const elements = lines.map((line, index) => {
//         if (line.startsWith('### ')) {
//             return <h3 key={index}>{line.slice(4)}</h3>;
//         } else if (line.startsWith('#### ')) {
//             return <h4 key={index}>{line.slice(5)}</h4>;
//         } else if (line.startsWith('- **')) {
//             const parts = line.slice(3).split(':');
//             const title = parts[0].replace(/\*\*/g, '').trim();
//             const content = parts.slice(1).join(':').trim();
//             return (
//                 <p key={index}>
//                     <strong>{title}:</strong> {content}
//                 </p>
//             );
//         } else if (line.startsWith('- ')) {
//             return <li key={index}>{line.slice(2)}</li>;
//         } else if (line.startsWith('**')) {
//             const parts = line.split('**');
//             return (
//                 <p key={index}>
//                     <strong>{parts[1]}:</strong> {parts[2]}
//                 </p>
//             );
//         } else {
//             return <p key={index}>{line}</p>;
//         }
//     });

//     return elements;
// };

const restHelpers = {
    modifyHistoryResponseData
};

export default restHelpers;